import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import React, { useState } from 'react';
import { headerTypographyProps } from '../../../styles/sxStyling';
import TemplateInput, { TemplateDisplay, TemplateOption } from './TemplateInput';
export type { TemplateDisplay, TemplateOption } from './TemplateInput';

interface TemplateModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onCreate: (templateUuid: string | null) => void;
  templates: TemplateOption[];
  title?: string;
}

export default function TemplateModal({ isOpen, onCancel, onCreate, templates, title = 'Create from Template' }: TemplateModalProps) {
  const [selectedOption, setSelectedOption] = useState<TemplateDisplay | null>(null);

  // Clears the current selection before closing the modal.
  const handleCancel = () => {
    setSelectedOption(null);
    onCancel();
  };

  // Passes either the selected template UUID or null for the blank template.
  const handleCreate = () => {
    if (!selectedOption) return;

    const templateUuid = selectedOption.uuid;

    setSelectedOption(null);
    onCreate(templateUuid);
  };

  return (
    <Dialog open={isOpen} onClose={handleCancel} fullWidth maxWidth="sm">
      <Typography {...headerTypographyProps} sx={{ m: 2 }}>
        {title}
      </Typography>

      <DialogContent>
        <TemplateInput templates={templates} value={selectedOption} onChange={setSelectedOption} autoFocus />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          Cancel
        </Button>

        <Button variant="contained" disabled={!selectedOption} color="primary" onClick={handleCreate}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
